import React from 'react'
import './in-status.scss'

export const InStatus: React.FC = (props) => {
  return (
    <div className="in-status">
      <p>{props.children}</p>
    </div>
  )
}

export default InStatus
